import { useAuthContext } from '../../context/auth.context'

export const useLoginSysAdmin = () => {
  const authContext = useAuthContext()
  return authContext.state.isSysRoot || authContext.state.isSysAdmin
}
